/**
 * Verification Screen
 * 
 * Loads the Verification (UCS) MFE for identity verification.
 * 
 * @module components/menu/VerificationScreen
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MFELoader } from '@/components/mfe/MFELoader';
import { useAuth } from '@/contexts/AuthContext';
import { CommunicationBridge } from '@sequelae/lore-mfe-kit';

export const VerificationScreen: React.FC = () => {
  const { user, logout } = useAuth();
  const token = CommunicationBridge.getAccessToken();
  const navigate = useNavigate();

  // Set up the verification completion callback
  useEffect(() => {
    console.log('[VerificationScreen] Setting up triggerOnModuleFinished callback');
    
    (window as any).triggerOnModuleFinished = (mfeType: string, data?: { appRoute?: string }) => {
      console.log('[VerificationScreen] Verification completed', { mfeType, data });
      
      if (mfeType === 'verification') {
        // Navigate to the specified route or default to home
        const targetRoute = data?.appRoute || '/home';
        console.log('[VerificationScreen] Navigating to:', targetRoute);
        navigate(targetRoute);
      }
    };

    // Cleanup on unmount
    return () => {
      console.log('[VerificationScreen] Cleaning up triggerOnModuleFinished callback');
      delete (window as any).triggerOnModuleFinished;
    };
  }, [navigate]);

  if (!token || !user) {
    return <div>Unauthorized</div>;
  }

  return (
    <MFELoader
      mfeName="Verification"
      accessToken={token}
      refUserId={user.id}
      onLogout={logout}
    />
  );
};

